import { gql } from '@apollo/client';
import ASSET_FRAGMENT from '../fragments/asset';

const SUPPORT_CATEGORY_FRAGMENT = gql`
  fragment BaseSupportCategory on SupportCategory {
    id
    iconAssetId
    title
    description
    sortIndex
    locale
    data
    iconAsset {
      ...BaseAsset
    }
  }
  ${ASSET_FRAGMENT}
`;

export default SUPPORT_CATEGORY_FRAGMENT;
